import Link from 'next/link';
import { AnchorHTMLAttributes, Ref } from 'react';

import { Link as I18nLink } from '@flipster/i18n/routing';

export interface IsomorphicLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  ref?: Ref<HTMLAnchorElement>;
  external?: boolean;
  newTab?: boolean;
  nonLocale?: boolean;
  prefetch?: boolean;
}

export const IsomorphicLink = ({
  ref,
  href,
  newTab,
  children,
  external,
  nonLocale,
  prefetch,
  ...restProps
}: IsomorphicLinkProps) => {
  const BaseLink = nonLocale ? Link : I18nLink;
  const prefetchEnabled = prefetch ?? (!external && !newTab);
  const targetProps = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : undefined;
  return (
    <BaseLink ref={ref} href={href || ''} {...targetProps} prefetch={prefetchEnabled} {...restProps}>
      {children}
    </BaseLink>
  );
};
